// extracted by mini-css-extract-plugin
module.exports = {"txContainer":"notifications_txContainer__1YcgM"};